import React from "react";
import BaseField from "./BaseField";

export default function CheckboxField({
  field,
  value,
  setValue,
  renderInlineChildren,
  openViewer,
  previewMode = false,
}) {
  const required = !!field.required;
  const label = field.label || "Checkbox";

  const checked = !!value;

  return (
    <BaseField
      field={field}
      value={value}
      setValue={setValue}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      {/* Label */}
      <h3 className="text-gray-800 dark:text-gray-100 text-lg font-bold mb-3 text-center">
        {label} {required && <span className="text-orange-500">*</span>}
      </h3>

      {/* Checkbox button */}
      <button
        type="button"
        onClick={() => setValue(!checked)}
        className={`w-full px-4 py-3 rounded-lg border font-semibold text-base transition-colors ${
          checked
            ? "bg-orange-500 border-orange-500 text-white"
            : "bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-800 dark:text-gray-100"
        }`}
      >
        {checked ? "☑ Checked" : "☐ Check"}
      </button>
    </BaseField>
  );
}
